module.exports = __webpack_public_path__ + "img/kanelsnurrer.26995e35.jpg";